function parentOf(parent, list) {
  return parent && parent.id ? list.find(category => category.id === parent.id) : null;
}

export function categoryPath(item, list = []) {
  const names = [item.name];
  const seen = new Set([item.id]);
  let { parent } = item;

  while (parent && parent.id && !seen.has(parent.id)) {
    seen.add(parent.id);
    const found = parentOf(parent, list);
    if (!found && !parent.name) break;
    names.unshift(found ? found.name : parent.name);
    parent = found ? found.parent : null;
  }

  return names.join(' > ');
}

export function categoryOptions(list) {
  return list
    .map(item => ({ value: item.id, text: categoryPath(item, list) }))
    .sort((a, b) => a.text.localeCompare(b.text));
}
